<template>
  <div class="Box">
    首页
  </div>
</template>
<script>
  export default {
    name: '',
    data(){
      return {

      }
    },
    components: {

    },
    computed:{

    },
    methods:{

    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style>

</style>
